var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4391 10.99L17.4291 11.01C17.4691 10.68 17.5091 10.34 17.5091 10C17.5091 9.66 17.4791 9.34 17.4391 9.01L17.4491 9.03L19.8891 7.11L17.4591 2.89L14.5891 4.05L14.5991 4.06C14.0791 3.66 13.5091 3.32 12.8891 3.06H12.8991L12.4391 0H7.56914L7.12914 3.07H7.13914C6.51914 3.33 5.94914 3.67 5.42914 4.07L5.43914 4.06L2.55914 2.89L0.119141 7.11L2.55914 9.03L2.56914 9.01C2.52914 9.34 2.49914 9.66 2.49914 10C2.49914 10.34 2.52914 10.68 2.57914 11.01L2.56914 10.99L0.469141 12.64L0.139141 12.9L2.56914 17.1L5.44914 15.95L5.42914 15.91C5.95914 16.32 6.52914 16.66 7.15914 16.92H7.12914L7.57914 20H12.4291C12.4291 20 12.4591 19.82 12.4891 19.58L12.8691 16.93H12.8591C13.4791 16.67 14.0591 16.33 14.5891 15.92L14.5691 15.96L17.4491 17.11L19.8791 12.91C19.8791 12.91 19.7391 12.79 19.5491 12.65L17.4391 10.99ZM9.99914 13.5C8.06914 13.5 6.49914 11.93 6.49914 10C6.49914 8.07 8.06914 6.5 9.99914 6.5C11.9291 6.5 13.4991 8.07 13.4991 10C13.4991 11.93 11.9291 13.5 9.99914 13.5Z",
    fill: "#C9C7D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsHead);
export default __webpack_public_path__ + "static/media/settings_head.88addc87c23ea5efcf0c7b8066db8b6a.svg";
export { ForwardRef as ReactComponent };